<template>
  <div class="box">
    <v-row>
      <v-col cols="12">
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-data-table
          :headers="headers" :items="roleUser" item-key="uname" :height="height"
          dense hide-default-footer disable-pagination fixed-header single-select>
          <template #item.changeDatim="{ value }">
            <span>{{ value | format('yyyy-MM-dd HH:mm:ss') }}</span>
          </template>
          <template #item.period="{ item }">
            <span>{{ item.fromDatim | format('yyyy-MM-dd HH:mm:ss') }} ~ {{ item.toDatim | format('yyyy-MM-dd HH:mm:ss') }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: Number,
    },
    roleUser: {
      type: Array,
    },
  },
  data() {
    return {
      headers: [
        { text: 'User', value: 'uname', sortable: false },
        { text: 'Assigned', value: 'changeDatim', sortable: false },
        { text: 'Period', value: 'period', sortable: false },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
